module.exports = __webpack_public_path__ + "img/Andrew Jones.7d131348.jpg";